import styled from 'styled-components';

// Cores dinâmicas do tema (mesmas do ProfileForm)
const colors = {
  primary: '#122D58', // Azul escuro
  secondary: '#FFF28D', // Amarelo (mesma cor do botão Importar Múltiplos XMLs)
  lightBlue: '#4FC3F7', // Azul claro
  background: '#F5F5F5',
  white: '#FFFFFF',
  gray: '#E0E0E0',
  darkGray: '#666666',
  text: '#333333',
  success: '#4CAF50',
  error: '#F44336',
};

export const Container = styled.div`
  padding: 0;
  width: 90vw;
  max-width: 100vw;
  margin: 0;
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -24px;
  margin-bottom: -24px;
  background-color: ${colors.background};
  min-height: calc(100vh - 64px);
`;

export const ModalContainer = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 30px;
  background: ${colors.white};
  box-shadow: none;
  overflow: hidden;
`;


export const ModalHeader = styled.div`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 16px 24px ;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.white};
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const HeaderSaveButton = styled.button`
  padding: 8px 20px;
  background-color: ${colors.secondary};
  color: ${colors.primary};
  border: none;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  
  &:hover {
    background-color: #FFEB3B;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 242, 141, 0.3);
  }
`;

export const HeaderCancelButton = styled.button`
  padding: 8px 20px;
  background-color: transparent;
  color: ${colors.white};
  border: 1px solid ${colors.white};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray};
  padding: 0 24px;
`;

export const Step = styled.div`
  padding: 16px 24px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  color: ${props => props.active ? colors.primary : colors.darkGray};
  font-weight: ${props => props.active ? '600' : '400'};
  border-bottom-color: ${props => props.active ? colors.secondary : 'transparent'};
  background-color: ${props => props.active ? 'rgba(255, 242, 141, 0.1)' : 'transparent'};
  
  &:hover {
    background-color: ${props => props.active ? 'rgba(255, 242, 141, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const StepNumber = styled.span`
  font-weight: 700;
  margin-right: 8px;
  color: ${props => props.active ? colors.primary : colors.darkGray};
`;

export const FormContent = styled.div`
  padding: 40px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.primary};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 0;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
`;

// Estilos para seção de veículos
export const VehiclesSection = styled.div`
  margin-top: 24px;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const VehiclesHeader = styled.div`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const VehiclesTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.white};
`;

export const VehiclesList = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const VehicleItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: ${colors.background};
  border-radius: 4px;
  border-left: 4px solid ${props => props.tipo === 'tração' ? colors.primary : colors.lightBlue};
`;

export const VehicleInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const VehicleLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.primary};
`;

export const VehicleDetails = styled.span`
  font-size: 12px;
  color: ${colors.darkGray};
`;

export const VehicleType = styled.span`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${props => props.tipo === 'tração' ? colors.primary : colors.lightBlue};
  color: ${colors.white};
  text-transform: uppercase;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  background-color: ${colors.background};
  border-radius: 4px;
  min-height: 60px;
`;

export const Chip = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props => props.selected ? colors.primary : colors.lightBlue};
  color: ${colors.white};
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  background-color: ${colors.background};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid ${colors.gray};
`;

export const SaveButton = styled.button`
  padding: 10px 24px;
  background-color: ${colors.secondary};
  color: ${colors.primary};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  
  &:hover {
    background-color: #FFEB3B;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 242, 141, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  background-color: ${colors.gray};
  color: ${colors.text};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #BDBDBD;
    color: ${colors.white};
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: ${colors.background};
  border-radius: 4px;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: ${colors.text};
  font-weight: 500;
`;

// Estilos globais para melhorar UX dos selects e options
export const GlobalSelectStyles = styled.div`
  /* Estilos para o select */
  .MuiSelect-root {
    padding: 12px 14px !important;
    font-size: 14px !important;
    color: ${colors.text} !important;
    background-color: ${colors.white} !important;
    border-radius: 4px !important;
    transition: all 0.3s ease !important;
    
    &:hover {
      background-color: ${colors.background} !important;
    }
    
    &:focus {
      background-color: ${colors.white} !important;
    }
  }
  
  /* Estilos para o menu dropdown */
  .MuiMenu-paper {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    margin-top: 8px !important;
    max-height: 300px !important;
  }
  
  /* Estilos para os options */
  .MuiMenuItem-root {
    padding: 12px 16px !important;
    font-size: 14px !important;
    color: ${colors.text} !important;
    transition: all 0.2s ease !important;
    min-height: 48px !important;
    display: flex !important;
    align-items: center !important;
    
    &:hover {
      background-color: rgba(18, 45, 88, 0.08) !important;
      color: ${colors.primary} !important;
    }
    
    &.Mui-selected {
      background-color: rgba(255, 242, 141, 0.2) !important;
      color: ${colors.primary} !important;
      font-weight: 600 !important;
      
      &:hover {
        background-color: rgba(255, 242, 141, 0.3) !important;
      }
    }
    
    &:active {
      background-color: rgba(18, 45, 88, 0.12) !important;
    }
  }
  
  /* Estilos para option nativo (fallback) */
  select option {
    padding: 12px 16px !important;
    font-size: 14px !important;
    color: ${colors.text} !important;
    background-color: ${colors.white} !important;
    min-height: 40px !important;
    
    &:hover {
      background-color: rgba(18, 45, 88, 0.08) !important;
    }
    
    &:checked,
    &:focus {
      background-color: rgba(255, 242, 141, 0.2) !important;
      color: ${colors.primary} !important;
      font-weight: 600 !important;
    }
  }
  
  /* Estilos para select nativo */
  select {
    option {
      padding: 12px 16px !important;
      font-size: 14px !important;
      color: ${colors.text} !important;
      background-color: ${colors.white} !important;
      
      &:hover {
        background-color: rgba(18, 45, 88, 0.08) !important;
      }
    }
    
    &:focus option:checked {
      background-color: rgba(255, 242, 141, 0.2) !important;
      color: ${colors.primary} !important;
      font-weight: 600 !important;
    }
  }
`;
